import { render } from "./SocialTiktok.vue?vue&type=template&id=2513ef99"
import script from "./SocialTiktok.vue?vue&type=script&lang=js"
export * from "./SocialTiktok.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/endangeredlabs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__